export const MAX_PREVIEW_TARGETS = 10
export const LARGE_BATCH_THRESHOLD = 50
export const QUESTION_PREVIEW_LENGTH = 60

export interface ConnectionTypeOption {
  value: string
  label: string
  description: string
  category: string
}

export const CONNECTION_TYPES: ConnectionTypeOption[] = [
  {
    value: 'network_connection',
    label: 'Network Connection',
    description: 'Standard network connectivity between devices',
    category: 'Infrastructure',
  },
  {
    value: 'physical_connection',
    label: 'Physical Connection',
    description: 'Physical IT infrastructure link (cables, ports)',
    category: 'Infrastructure',
  },
  {
    value: 'contains',
    label: 'Contains',
    description: 'Source contains target (e.g., rack contains server)',
    category: 'Infrastructure',
  },
  {
    value: 'resides_on',
    label: 'Resides On',
    description: 'Target resides on source (e.g., file on workstation)',
    category: 'Infrastructure',
  },
  {
    value: 'management',
    label: 'Management',
    description: 'Admin/management relationship',
    category: 'Infrastructure',
  },
  {
    value: 'dependency',
    label: 'Dependency',
    description: 'Source depends on target',
    category: 'Infrastructure',
  },
  {
    value: 'lateral_movement',
    label: 'Lateral Movement',
    description: 'Attacker moved from source to target',
    category: 'Forensic',
  },
  {
    value: 'data_exfiltration',
    label: 'Data Exfiltration',
    description: 'Data stolen from source to target',
    category: 'Forensic',
  },
  {
    value: 'authentication',
    label: 'Authentication',
    description: 'Auth event between systems',
    category: 'Forensic',
  },
  {
    value: 'file_transfer',
    label: 'File Transfer',
    description: 'Files transferred between systems',
    category: 'Forensic',
  },
  {
    value: 'remote_execution',
    label: 'Remote Execution',
    description: 'Remote code execution',
    category: 'Forensic',
  },
  {
    value: 'rdp_session',
    label: 'RDP Session',
    description: 'Remote Desktop session',
    category: 'Forensic',
  },
  {
    value: 'ssh_session',
    label: 'SSH Session',
    description: 'SSH connection',
    category: 'Forensic',
  },
  {
    value: 'smb_share',
    label: 'SMB Share',
    description: 'SMB/file share access',
    category: 'Forensic',
  },
  {
    value: 'command_and_control',
    label: 'Command & Control',
    description: 'C2 communication',
    category: 'Forensic',
  },
  {
    value: 'unknown',
    label: 'Unknown',
    description: 'Relationship type not yet determined',
    category: 'Other',
  },
  { value: 'other', label: 'Other', description: 'Other relationship type', category: 'Other' },
]

export const RELATIONSHIP_STATUSES = [
  { value: 'confirmed', label: 'Confirmed', description: 'Relationship verified with evidence' },
  {
    value: 'suspected',
    label: 'Suspected',
    description: 'Relationship suspected but not confirmed',
  },
  {
    value: 'open-question',
    label: 'Open Question',
    description: 'Marks an investigative question',
  },
]

export function groupConnectionTypes(): Record<string, ConnectionTypeOption[]> {
  return CONNECTION_TYPES.reduce<Record<string, ConnectionTypeOption[]>>((acc, type) => {
    const cat = type.category
    acc[cat] ??= []
    acc[cat].push(type)
    return acc
  }, {})
}
